import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { nextTick, reactive, ref, watch } from 'vue'
import { SignApi, ValidateApi } from '.'

interface Props {
  modelValue: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'form',
  props: {
    modelValue: null
  },
  emits: ["submit", "update:modelValue", "toggle"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'submit', form: SignApi): void
  (e: 'update:modelValue', key: string): void
  (e: 'toggle', val: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: string
}



const form = reactive<SignApi>({
  type: '',
  email: '',
  password: ''
})

const checkEmail: ValidateApi = (rule, value, callback) => {
  const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
  if (!value) {
    return callback('请输入邮箱!')
  }
  if (!emailReg.test(value)) callback('邮箱地址不合法')
  callback()
}

const validatePass: ValidateApi = (rule, value, callback) => {
  if (!value) {
    callback('请确认密码')
  } else if (value != form.password) {
    callback('输入密码不一致')
  } else {
    callback()
  }
}
const ruleFormRef = ref()

const rules = ref()
const rules1 = reactive({
  email: {
    required: true,
    validator: checkEmail,
    trigger: 'blur'
  },
  password: {
    required: true,
    message: '请输入密码'
  }
})

const rules2 = reactive({
  email: {
    required: true,
    validator: checkEmail,
    trigger: 'blur'
  },
  password: {
    required: true,
    message: '请输入密码'
  },
  checkPass: {
    required: true,
    validator: validatePass,
    trigger: 'blur'
  }
})

const param = reactive({
  type: '',
  one: { key: '', value: '' },
  two: { key: '', value: '' }
})

watch(
  () => props.modelValue,
  val => {
    nextTick(() => reset())
    switch (val) {
      case 'login':
        rules.value = rules1
        param.type = '登录'
        param.one = { key: 'register', value: '邮箱注册' }
        param.two = { key: 'forget', value: '忘记密码' }
        break
      case 'register':
        rules.value = rules1
        param.type = '注册'
        param.one = { key: 'login', value: '邮箱登录' }
        param.two = { key: '', value: '' }
        break
      case 'forget':
        rules.value = rules2
        param.type = '修改密码'
        param.one = { key: 'login', value: '邮箱登录' }
        param.two = { key: '', value: '' }
        break
    }
  },
  { immediate: true }
)



function submit() {
  form.type = props.modelValue
  ruleFormRef.value.validate((valid: any) => {
    if (valid) {
      emit('submit', form)
    }
  })
}

function reset() {
  ruleFormRef.value.resetFields()
}

expose({
  reset
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "ruleFormRef",
    ref: ruleFormRef,
    model: form,
    rules: rules.value,
    class: "select-none"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, { prop: "email" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: form.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.email) = $event)),
            placeholder: "请输入邮箱",
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle', 1))),
            onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle', 0)))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { prop: "password" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: form.password,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.password) = $event)),
            placeholder: "请输入密码",
            onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('toggle', 2))),
            onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('toggle', 0)))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_el_form_item, { prop: "checkPass" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: form.checkPass,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.checkPass) = $event)),
            placeholder: "请确认密码",
            onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('toggle', 2))),
            onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('toggle', 0)))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 512), [
        [_vShow, __props.modelValue == 'forget']
      ]),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            style: {"width":"100%"},
            type: "primary",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(param.type), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('update:modelValue', param.one.key)))
          }, _toDisplayString(param.one.value), 1),
          _createElementVNode("div", {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('update:modelValue', param.two.key)))
          }, _toDisplayString(param.two.value), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})